import { http } from '../../config/axios'

export default function getZipNotaFiscalFaturamento(id: number): Promise<Blob> {
  return http
    .get('api/faturamento/zip-nota-fiscal/' + id, {
      responseType: 'blob'
    })
    .then((r) => r.data)
    .then((blobFile) => {
      return blobFile
    })
}
